<template>
    <div
        class="bg-white" :class="{
            'border-danger' : !valid,
            'p-0': mini,
            'p-3 border shadow-sm rounded': !mini,
        }"
        @click="$emit('reset-validation', true)"
    >
        <b-icon v-if="!valid" icon="exclamation-circle" class="text-danger float-right"/>
        <div v-for="programme in Object.keys(groupsByProgrammeAndYear)" :key="programme">

            <div v-if="Object.keys(groupsByProgrammeAndYear).length > 1" class="form-group" :class="mini ? 'mb-2' : 'mb-3'">
                <label for="selectProgramme">{{ $t('programme') }}</label>
                <b-form-select
                    id="selectProgramme"
                    v-model="activeProgramme"
                    :options="Object.keys(groupsByProgrammeAndYear).map(key => { return { value: key, text: $config.getProgrammeNameById(key) }})"
                />
            </div>

            <div v-for="year in Object.keys(groupsByProgrammeAndYear[programme])" :key="`${programme}.${year}`" class="d-flex flex-column" :class="mini ? 'mb-2' : 'mb-3'">
                <div class="d-flex flex-row align-items-center">
                    <input
                        :id="`year-${year}`"
                        type="checkbox"
                        class="form-check mr-2"
                        :checked="yearSelected(year)"
                        @click="disabled ? undefined : toggleYearSelected(year)"
                        :disabled="disabled"
                    />
                    <label :for="`year-${year}`" class="form-check-label" :class="{ 'text-sm': mini }">{{ `${$t('year')} ${year}` }}</label>
                </div>

                <div class="d-flex flex-row flex-wrap" v-if="innerValue !== undefined">
                    <div
                        v-for="group in groupsByProgrammeAndYear[programme][year]"
                        :key="`${programme}.${year}.${group.group_id}`"
                        class="btn"
                        :class="`${isSelected(group) ? 'btn-primary' : 'btn-outline-dark'} ${mini ? 'btn-sm mr-1 mt-1' : 'mr-2 mt-2'}`"
                        @click="disabled ? undefined : toggleGroupSelected(group)"
                    >
                        {{ group.title ? group.title : $config.getGroupNameById(group.group_id) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        groups: Array,
        value: Array,
        valid: {
            type: Boolean,
            default: true,
        },
        disabled: Boolean,
        sortedGroups: Object,   // If passed, groups prop is ignored, must be sorted by programme and year
        mini: Boolean,
    },
    data() {
        return {
            activeProgramme: undefined,
            groupsByProgrammeAndYear: {},
            innerValue: [...this.value],
        }
    },
    beforeMount() {
        // Let's structure our groups by year and programme in a dictionary
        if (this.sortedGroups) {
            this.groupsByProgrammeAndYear = this.sortedGroups
            return
        }
        this.sortGroups(this.groups)
     },
    methods: {
        sortGroups(groups) {
            this.groupsByProgrammeAndYear = {}
            
            for (const group of groups) {
                if (this.groupsByProgrammeAndYear[group.programme_id] === undefined) {
                    this.groupsByProgrammeAndYear[group.programme_id] = {}
                    this.groupsByProgrammeAndYear[group.programme_id][group.year] = [group]
                    continue
                }
                if (this.groupsByProgrammeAndYear[group.programme_id][group.year] === undefined) {
                    this.groupsByProgrammeAndYear[group.programme_id][group.year] = [group]
                    continue
                }
                this.groupsByProgrammeAndYear[group.programme_id][group.year].push(group)
            }

            this.activeProgramme = Object.keys(this.groupsByProgrammeAndYear)[0]
        },
        toggleYearSelected(year) {
            const someSelected = this.innerValue.some(group => group.year == year)

            if (someSelected) {
                this.innerValue = this.innerValue.filter(group => group.year != year)
            } else {
                this.innerValue.push(...this.groupsByProgrammeAndYear[this.activeProgramme][year])
            }

            this.$emit('input', [...this.innerValue])
        },
        toggleGroupSelected(group) {
            const index = this.innerValue.findIndex(el => this.checkGroupEquality(el, group))

            if (index > -1) this.innerValue.splice(index, 1)
            else this.innerValue.push(group)

            this.$emit('input', [...this.innerValue])
        },
        isSelected(group) {
             return this.innerValue.findIndex(el => this.checkGroupEquality(el, group)) > -1
        },
        yearSelected(year) {
            return this.innerValue.some(group => group.year == year)
        },
        checkGroupEquality(group0, group1) {
            return group0.programme_id == group1.programme_id
                && group0.year == group1.year
                && group0.group_id == group1.group_id
        },
    },
    watch: {
        value(newVal) {
            this.innerValue = [...newVal]
        },
        groups(newGroups) {
            this.sortGroups(newGroups)
        }
    }
}
</script>
